import { createMutationHelper } from '@utils/swr'
import { type CampaignCalculateParams, type CampaignCalculateRequest } from '../types/apiRequest'
import { type CampaignCalculateResponse } from '../types/apiResponse'
import { type FortuneApis } from '../types/apis'

const { useMutation } = createMutationHelper<FortuneApis['post']['campaignCalculate'], CampaignCalculateResponse, CampaignCalculateRequest, CampaignCalculateParams>({
  client: 'fortune',
  key: params => params?.campaign_code ? `/campaigns/${params?.campaign_code}/calculate` : null,
  fetcher: (url, { client, arg }) => {
    if (!arg.campaign_code || !arg.order_items) {
      throw new Error('[useApiCalculateCampaignCoupons] campaign_code and order_items are required!')
    }
    if (arg.order_items.some(order_item => !order_item.sku)) {
      throw new Error('[useApiCalculateCampaignCoupons] sku is required in order_items')
    }
    return client.post(url, {
      ...arg,
      order_items: arg.order_items?.map(order_item => ({
        ...order_item,
      })),
    })
  },
})

export const useApiCalculateCampaignCoupons = useMutation
